import * as React from 'react'
import ReactPlayer from 'react-player'
import styled from 'styled-components'
import { VideoManagerItem, VideoManagerVideoType } from './VideoManager'

interface Props {
    video: VideoManagerItem

}
const VideoContainer = styled.div`
    position: relative;    
    margin-bottom: 25px;
    margin-top:10px;
    height:300px;
    .react-player {
        height:300px;
    }
`

const VideoDisplay = (props: Props) => {
    if (props.video.type == VideoManagerVideoType.VK) {
        let _src = ""
        if (props.video.url.indexOf("video_ext") >= 0) {
            _src = props.video.url
        }
        else {
            const parts = props.video.url.split('-')
            const ids = parts[1].split('_')
            _src = `https://vk.com/video_ext.php?oid=-${ids[0]}&id=${ids[1]}&autoplay=0`
        }
        return <iframe src={_src} width="100%" height="300px" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"></iframe>
    }
    else {
        return <VideoContainer>
            <ReactPlayer className="react-player" url={props.video.url} width={'100%'} height={'100%'} />
        </VideoContainer>
    }
}
export default VideoDisplay
